import { createFileRoute } from '@tanstack/react-router';

import { AuditFormPage } from '@/features/audit-workflow/components/AuditFormPage';
import i18n from '@/lib/i18n';

export const Route = createFileRoute('/_authenticated/audit/audits/$auditId/settings')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.auditSettings'),
  }),
  component: AuditSettingsRoute,
});

function AuditSettingsRoute() {
  const { auditId } = Route.useParams();
  return <AuditFormPage mode="edit" auditId={auditId} />;
}
